/**
 * Human-readable labels for boat form fields used in validation error toasts.
 * Single source of truth — imported by useCanvasBoatActions (the canvas).
 */
export const WIZARD_FIELD_LABELS: Record<string, string> = {
  manufacturer: 'Manufacturer',
  model: 'Model',
  model_year: 'Year',
  our_price: 'Our Price',
  location_ids: 'Location',
  primary_location_id: 'Primary Location',
  engines: 'Engines',
  condition: 'Condition',
  website_status: 'Website Status',
};
